import { ChangeDetectionStrategy, Component, ElementRef, inject } from '@angular/core';
import { toSignal } from '@angular/core/rxjs-interop';
import {
  ActivitySectionDirective,
  CallWaiterService,
  RestaurantTableService,
  UserActivityClickTrackingDirective,
} from '@core';
import { ButtonCallWaiterMainComponent } from '@app/components/button-call-waiter-main/button-call-waiter-main.component';
import { ServiceCenterAmenitiesComponent } from '@app/components/service-center-amenities/service-center-amenities.component';
import { PageHeaderBackSwipeConfig, PageHeaderComponent } from '@app/components/page-header/page-header.component';
import { ButtonCallWaiterBillComponent } from '@app/components/button-call-waiter-bill/button-call-waiter-bill.component';

@Component({
  selector: 'app-page-service',
  styleUrl: './service.component.scss',
  templateUrl: './service.component.html',
  imports: [
    UserActivityClickTrackingDirective,
    ActivitySectionDirective,
    ButtonCallWaiterMainComponent,
    ServiceCenterAmenitiesComponent,
    PageHeaderComponent,
    ButtonCallWaiterBillComponent,
  ],
  host: {
    'class': 'page',
  },
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ServiceComponent {

  private readonly restaurantTable = inject(RestaurantTableService);
  public readonly callWaiterService = inject(CallWaiterService);
  private readonly elementRef = inject<ElementRef<HTMLElement>>(ElementRef);

  protected readonly backSwipeConfig: PageHeaderBackSwipeConfig = {
    direction: 'vertical',
    element: this.elementRef.nativeElement,
  };

  public readonly table = toSignal(this.restaurantTable.table$);

  public readonly withCallWaiterMain = toSignal(this.callWaiterService.withMain$, {
    initialValue: false,
  });

  public readonly withCallWaiterRequestBill = toSignal(this.callWaiterService.withSecondary$, {
    initialValue: false,
  });

  public readonly callWaiterMain = toSignal(this.callWaiterService.mainStatus$, {
    initialValue: true,
  });

  public readonly collWaiterRequestBill = toSignal(this.callWaiterService.secondaryStatus$, {
    initialValue: true,
  });

}
